import axios from 'axios'
import router from '../router/index';

axios.defaults.crossDomain = true
axios.defaults.withCredentials = false
// post请求头
// axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8'

axios.defaults.headers.common['Content-Type'] = 'multipart/form-data'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// 请求超时时间
// axios.defaults.timeout = 30000;
// axios.defaults.baseURL = process.env.VUE_APP_API_URL + '/api';
// axios.defaults.baseURL = "/api";

axios.defaults.baseURL = process.env.VUE_APP_BASE_API

// const appid = "wx01a89608b1816970"
const appid = "wx0361398af1586992"

// 请求拦截器
axios.interceptors.request.use(
    config => {
        let token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = 'Bearer ' + token
        }
        return config
    },
    error => {
        return Promise.reject(error)
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.code === 401) {
            let token = localStorage.getItem('token');
            if (token) {
                localStorage.removeItem("token");
                localStorage.removeItem("username");
                localStorage.removeItem("expires");
                // window.location.href = process.env.VUE_APP_WEB_URL;
            }

        }
        return Promise.resolve(response)
    },
    error => {
        return Promise.reject(error)
    }
)

function get(url, params) {
    let platform = 4;
    if (url == '/console/pay') {
        platform = 1;
    }
    if (url == '/user/loginVerify' || url == "/user/login") {
        platform = 7;
    }
    return new Promise((resolve, reject) => {
        axios.get(url, { ...params, platform: platform, platform_source_from: 7 }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * post方法，对应post请求
 * @param  url 请求的url地址
 * @param  params 请求时携带的参数
 **/
function post(url, params) {
    let platform = 4;
    let platform_source_from = 7
    if (url == '/console/pay') {
        platform = 1;
    }
    if (url == '/user/loginVerify' || url == "/user/login") {
        platform = 7;
    }
    if (url == '/console/points/bill' || url == "/console/packageOrderList") {
        platform_source_from = "";
    }
    return new Promise((resolve, reject) => {
        axios.post(url, { ...params, platform: platform, platform_source_from: platform_source_from }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}




export default {
    appid,
    get,
    post
}
